

export const OpenSolicitudEditarModificacion = (modalAction, detalleSolicitudSol) => ({
  type: "OPEN_SOLICITUD_EDITAR_MODIFICACION",
  modalAction,
  detalleSolicitudSol,
});

export const CambiarInicioVigenciaArancel = (inicioVigenciaArancel, error) => ({
  type: "SOLEDIT_MODIFICACION/CAMBIAR_INICIO_VIGENCIA_ARANCEL",
  inicioVigenciaArancel,
  error,
});

export const CambiarMontoArancelPrestacion = (montoArancelPrestacion, error) => ({
  type: "SOLEDIT_MODIFICACION/CAMBIAR_MONTO_ARANCEL_PRESTACION",
  montoArancelPrestacion,
  error,
});
export const CambiarMontoArancelError = (errorArancelPrestacion) => ({
  type: "SOLEDIT_MODIFICACION/CAMBIAR_MONTO_ARANCEL_ERROR",
  errorArancelPrestacion,

});
export const CambiarTipoUnidad = (tipoUnidad, error) => ({
  type: "SOLEDIT_MODIFICACION/CAMBIAR_TIPO_UNIDAD",
  tipoUnidad,
  error,
});
